import { ComponentWithPermissions } from '../../../../../baseComponents/CreateRoutering/types'
import { permissionCheck } from '../../../../../baseComponents/PermissionChecker/function'
import TwinTable from '../../../../../baseComponents/TwinTable'
import BaseScreenTable from '../../../../../baseComponents/TwinTable/BaseScreenTable'
import { TableComponentProps } from '../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { CustomRenderString, DeleteRow, EditRow } from '../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'
import ModalCESellVariable from './ModalCESellVariable'
import ModalDeleteSellVariable from './ModalDeleteSellVariable'
import { SellVariableModelType, SellVariableTypeKeys } from '@teinor/erp/types/company/config/sellVariable'

interface ConfigSellVariablesProps extends ComponentWithPermissions {}

const ConfigSellVariables: React.FC<ConfigSellVariablesProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('sellVariables', 'Variables de venta'),
        newText: t('newSellVariable', 'Nueva variable de venta'),
    }

    return (
        <BaseScreenTable TableComponent={TableSellVariables} CreateModalComponent={ModalCESellVariable} EditModalComponent={ModalCESellVariable} DeleteModalComponent={ModalDeleteSellVariable} pageData={pageData} userPermissions={userPermissions} />
    )
}

interface TableSellVariablesProps extends TableComponentProps { }

const TableSellVariables: React.FC<TableSellVariablesProps> = ({ userPermissions, setTableInstance, setOpened }) => {
    const { t } = useTwinTranslation()
    const dictTypes: Record<SellVariableTypeKeys, string> = {
        0: t('number', 'Número'),
        1: t('text', 'Texto'),
        2: t('price', 'Precio'),
        3: t('selector', 'Selector')
    }
    const columns: ColumnTableSchema<SellVariableModelType> = [
        {
            id: 'id',
            dataKey: 'id',
            label: t('id', 'ID'),
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('id', 'ID') }
            }
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            }
        },
        {
            id: 'type',
            dataKey: 'type',
            label: t('type', 'Tipo'),
            customRender: (paramaterValue) => <CustomRenderString value={dictTypes?.[parseInt(paramaterValue) as SellVariableTypeKeys] || ''} />
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'edit', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'update')
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'delete')
        }
    ]
    return (
        <TwinTable name='sellVariables' columns={columns} getDataFrom='/api/app/config/sell/sellVariable/getAllSellVariables' setTableInstance={setTableInstance} onRowClick={(_id, rowData) => setOpened({ type: 'edit', allRowData: rowData })} extraWhereParams={{ active: true }} />
    )
}

export default ConfigSellVariables